export const accommodationFields = [
  { key: "GuestAmount", label: "Guests", max: 99 },
  { key: "Bedrooms", label: "Bedrooms", max: 99 },
  { key: "Bathrooms", label: "Bathrooms", max: 99 },
  { key: "Beds", label: "Beds", max: 99 },
];
